<div class="panel-body">
    <div class="card">
        @if (hasProducts()) {
            <div class="card-header hidden-mobile">
                <span class="pull-left" translate="cart.order.history.product"></span>
                @for (label of visibleHeaderLabels(); track $index) {
                    <span translate="{{ label }}"></span>
                }
            </div>
            @for (viewProduct of orderView().products; track $index) {
                <order-history-product (itemAdded)="itemAdded.emit($event)"
                                       [viewProduct]="viewProduct" [displayAttributes]="visibleDisplayAttributes()" [currencyCode]="orderView().currencyCode" [orderId]="orderView().id"></order-history-product>
            }
        } @else {
            <div class="card-body">
                <span class="pull-left" translate="cart.order.history.no.products"></span>
            </div>
        }
    </div>
</div>
